import React from "react";
import { DualAxes } from "@ant-design/plots";
import styled from "styled-components";
import { formatDataNumberToen } from "../../helper/helper";

export default function DashboardPages({
  dataDashboard,
  isHiddenContainer = false,
  width = 600,
}) {
  const { data, xField, yField, annotations } = dataDashboard;

  const config = {
    data: [data, data],
    xField: xField,
    yField: yField,

    yAxis: {
      [yField[0]]: {
        label: {
          formatter: (v) => ` ${formatDataNumberToen(+v)} `,
        },
      },
      [yField[1]]: {
        label: {
          formatter: (v) => ` ${formatDataNumberToen(+v)} `,
        },
      },
    },

    tooltip: {
      formatter: (datum) => {
        let namActive = yField[1];
        if (
          datum[yField[0]] ||
          datum[yField[0]] === 0 ||
          datum[yField[0]] === "0"
        ) {
          namActive = yField[0];
        }
        return {
          name: namActive,
          value: `${formatDataNumberToen(+datum[namActive])}`,
        };
      },
    },

    geometryOptions: [
      {
        geometry: "column",
      },
      {
        geometry: "line",
        lineStyle: {
          lineWidth: 2,
        },
      },
    ],
    annotations,
  };
  return (
    <Container
      className={`${!isHiddenContainer ? "container" : ""}`}
      width={width}
    >
      <div className="dash-board">
        <DualAxes {...config} />
      </div>
    </Container>
  );
}
const Container = styled.div`
  width: 100%;
  overflow-x: auto;

  .dash-board {
    min-width: ${(props) => props.width}px;
    overflow: auto;
  }
`;
